export default "__VITE_ASSET__DTrBndJw__"